import classNames from 'classnames';
import { useController } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Radio from 'style-guide/Radio';
import theme from 'style-guide/Theme';
import Text from 'style-guide/Typography/Text';

const LikertScaleAnswer = ({ answer, index, control, type, questionId, answeredTest }) => {
  const {
    field: { onChange, value },
  } = useController({ control, name: `answers.${index}` });

  const { testNumber } = useParams();

  const userAnswer = answeredTest?.userAnswers?.[questionId];

  return (
    <div className={classNames('d-flex justify-content-center likert-scale-block', { 'preview-mode': testNumber })}>
      {answer.map((item) => (
        <Radio
          className='likert-scale mr--40 mt--16'
          key={item.id}
          onChange={() => onChange({ type, questionId, answer: [item.id] })}
          checked={testNumber ? answeredTest && Number(userAnswer) === item.id : value?.answer?.[0] === item.id}
        >
          <Text $variant={2} className='mb--16' color={theme().colors.dark[60]}>
            {item.answer}
          </Text>
        </Radio>
      ))}
    </div>
  );
};

export default LikertScaleAnswer;
